import PropTypes from 'prop-types';

const FullScreenLayout = ({ children }) => {
  return (
    <div
      fluid
      className="d-flex flex-column align-content-between justify-content-between login-background p-0">
      <div className="flex-fill background-color-dark">{children}</div>
    </div>
  );
};

FullScreenLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default FullScreenLayout;
